/* --------------------------------------------------------------------------------------------
Project Name: Rem2Cloud (R2C)
File Name: user.model.ts
File Description: Defines model for user component

Copyright 2023 - 2024 Otis Elevator Company
The software on this media is protected by law. Unauthorized use, reproduction or reverse engineering without
the express permission of Otis Elevator Company. is strictly prohibited.
Unpublished Work. All Rights Reserved.
------------------------------------------------------------------------------------------------- */


export interface callType {
  id: number,
  isDisplay: number,
  group: string,
  isDisabled: boolean,
  type: string
}

// Call types/ commissioning types
export const userCalltypes: callType[] = [
  { id: 1, isDisplay: 1, group: '1', isDisabled: false, type: 'Commissioning' },
  { id: 2, isDisplay: 1, group: '1', isDisabled: false, type: 'Production' },
  { id: 3, isDisplay: 1, group: '2', isDisabled: false, type: 'FactoryTest' },
  { id: 4, isDisplay: 0, group: '3', isDisabled: false, type: 'Operations' }
];

export interface empType {
  id: number,
  text: string,
  type: string
}
export const empTypes: empType[] = [
  { id: 1, text: 'employee', type: 'Employee' },
  { id: 2, text: 'contractor', type: 'Contractor' }
];

